import { render, staticRenderFns } from "./EventGroupItem.vue?vue&type=template&id=6d53e616&scoped=true&"
import script from "./EventGroupItem.vue?vue&type=script&lang=ts&"
export * from "./EventGroupItem.vue?vue&type=script&lang=ts&"
import style0 from "./EventGroupItem.vue?vue&type=style&index=0&id=6d53e616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d53e616",
  null
  
)

export default component.exports